/**
 * Normalize a page path for route matching (strip query, hash, leading slash).
 * @param {string} path
 * @returns {string}
 */
export const normalizePagePath = (path) => (
  path.split(/[?#]/)[0].replace(/^\//, '')
);

/**
 * Find a detail page config from the current pathname.
 * @param {ApiPage[]} pages
 * @param {string} pathname
 * @returns {ApiPage | null}
 */
export const findDetailPageByPathname = (pages, pathname) => {
  const normalizedPathname = normalizePagePath(pathname);
  return pages.find((page) => normalizePagePath(page.path) === normalizedPathname) ?? null;
};

/**
 * Normalize page template for detail routing (dashboard → detail).
 * @param {ApiPage} page
 * @returns {ApiPage}
 */
export const normalizeDetailPage = (page) => ({
  ...page,
  template: page.template === 'dashboard' ? 'detail' : page.template,
});
